import { Switch as MuiSwitch, } from '@mui/material';
import { alpha, styled } from '../../utils';
export const Switch = styled(MuiSwitch, {
    shouldForwardProp: (prop) => prop !== 'size',
})(({ size, theme }) => ({
    width: size === 'medium' ? 64 : 50,
    height: size === 'medium' ? '37px' : '29px',
    display: 'flex',
    padding: 0,
    overflow: 'initial',
    '.MuiSwitch-switchBase': {
        padding: 4,
        margin: 0,
        top: '50%',
        left: 0,
        transform: 'translate(0, -50%)',
        color: theme.palette.white.dark,
        speak: 'never',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontVariant: 'normal',
        textTransform: 'none',
        lineHeight: '1',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
        '&.Mui-checked': {
            transform: 'translate(-100%, -50%)',
            left: '100%',
            color: theme.palette.common.white,
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
            },
            '& .MuiSwitch-thumb': {
                opacity: 1,
                border: `1px solid ${theme.palette.primary.dark}`,
                backgroundColor: theme.palette.common.white,
            },
            '&+ .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.dark,
                border: `1px solid ${theme.palette.primary.dark}`,
            },
        },
        '&.Mui-disabled': {
            '& .MuiSwitch-thumb': {
                backgroundColor: alpha(theme.palette.primary.dark, 0.5),
                borderColor: alpha(theme.palette.primary.dark, 0.1),
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.common.white,
                borderColor: alpha(theme.palette.primary.main, 0.5),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.primary.dark,
        border: `1px solid ${theme.palette.primary.dark}`,
        boxShadow: 'none',
        width: size === 'medium' ? '32px' : '24px',
        height: size === 'medium' ? '32px' : '24px',
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 22,
        backgroundColor: theme.palette.common.white,
    },
}));
